import { type StatisticsTypeProps } from './types';
import { flexflowStatisticsData } from './flexflowStatisticsData';
import { payflowStatisticsData } from './payflowStatisticsData';

export const statistics = (props: StatisticsTypeProps) => {
  const { t, theme, currentCompany } = props;

  return {
    flexflowStatistics: flexflowStatisticsData(t, theme, currentCompany),
    payflowStatistics: payflowStatisticsData(t, theme, currentCompany)
  };
};
